import React, {useState} from "react";
import {Link} from "react-router-dom";
import {ButtonDropdown, DropdownItem, DropdownMenu, DropdownToggle} from "reactstrap";
import IconLabel from "../../../shared/components/IconLabel";
import {BoltIcon, PencilIcon, PrinterIcon} from "../../../shared/components/icons";
import {ACTIONS} from "./actionConfig";

/**
 * The "Ações" menu beside the title: what is done to the order itself rather
 * than moving it along: Imprimir (the paper version, in a new tab), Editar, and the way out (cancel, or cancel and
 * clone), kept apart from the flow buttons. The confirmation is shown by
 * OrderActions. Nothing is shown when the API offers none of these.
 * @param {{
 *   order: import("../../../api/types").Order,
 *   action: ReturnType<typeof import("./useOrderAction").useOrderAction>,
 * }} props
 */
const OrderMenu = ({order, action}) => {
    const [open, setOpen] = useState(false);
    const available = order.available_actions ?? [];
    const canEdit = available.includes("edit");
    const canCancel = available.includes("cancel");

    const canPrint = available.includes("print");

    if (!canEdit && !canCancel && !canPrint) return null;

    // `inNavbar` makes reactstrap skip Popper, which doesn't position the menu
    // here (it ended up on top of the button), and lets Bootstrap's CSS put it
    // right below, aligned to the end.
    return (
        <ButtonDropdown inNavbar isOpen={open} toggle={() => setOpen((value) => !value)}>
            <DropdownToggle caret color="primary" outline size="sm">
                <IconLabel icon={<BoltIcon />}>Ações</IconLabel>
            </DropdownToggle>
            <DropdownMenu end>
                {canPrint && (
                    <DropdownItem tag="a" href={`/orders/${order.id}/print`} target="_blank" rel="noopener noreferrer">
                        <IconLabel icon={<PrinterIcon size={16} />}>Imprimir</IconLabel>
                    </DropdownItem>
                )}
                {canPrint && (canEdit || canCancel) && <DropdownItem divider />}
                {canEdit && (
                    <DropdownItem tag={Link} to={`/orders/${order.id}/edit`}>
                        <IconLabel icon={<PencilIcon size={16} />}>Editar</IconLabel>
                    </DropdownItem>
                )}
                {canEdit && canCancel && <DropdownItem divider />}
                {canCancel && (
                    <>
                        <DropdownItem className="text-danger" onClick={() => action.ask("cancel")}>
                            <IconLabel icon={<ACTIONS.cancel.icon />}>{ACTIONS.cancel.label}</IconLabel>
                        </DropdownItem>
                        <DropdownItem className="text-danger" onClick={() => action.ask("cancelAndClone")}>
                            <IconLabel icon={<ACTIONS.cancelAndClone.icon />}>{ACTIONS.cancelAndClone.label}</IconLabel>
                        </DropdownItem>
                    </>
                )}
            </DropdownMenu>
        </ButtonDropdown>
    );
};

export default OrderMenu;
